import React from "react";
import styled from "styled-components";


export default styled.div`

    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.8;
    z-index: 999;
    background: white;
    
    i { 
        
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 40px;
        transform: translate(-50%, -50%);
        -webkit-animation: spin 4s infinite linear;
        
        
    ${(props) => (props.registration ? {
    'top': '41%',
    'left': '46%'
} : '')}
    }
       
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;